export default "__VITE_ASSET__Ce58gzBS__"